import { calculateIsFinalMonthOfData, dateFormatServer } from '@alluradirect/react';

import dayjs from 'dayjs';

/** Fetch 3 Months in the past */
function calculateInitialStartDate(): Date {
  return dayjs().subtract(3, 'month').startOf('month').toDate();
}

/**  We Fetch 1 year in the future as the Calendar Page has a table for 1 year of events */
export function calculateInitialEndDate(): Date {
  return dayjs().add(3, 'year').endOf('month').toDate();
}

export function getNextEndDate(date: Date): Date {
  return dayjs(date).add(1, 'year').toDate();
}

// This function is used to generate the default start/end dates for calendar dates/events
export const calculateCalendarInitialDates = () => {
  const defaultStart = dateFormatServer(calculateInitialStartDate());
  const defaultEnd = dateFormatServer(calculateInitialEndDate());

  return { defaultStart, defaultEnd };
};

export const getPreviousPageParam = (lastPage: any, minSearchDate: string) => {
  const lastStartDate = dayjs(lastPage.startDate);
  const isFinalMonthOfData = calculateIsFinalMonthOfData(lastPage.startDate, minSearchDate);

  // Return undefined to tell the hook to stop fetching
  if (isFinalMonthOfData) return undefined;
  const nextStartDate = lastStartDate.subtract(1, 'day').startOf('month');
  const nextStartDateString = nextStartDate.format('YYYY-MM-DD');

  const nextEndDate = nextStartDate.endOf('month');
  const nextEndDateString = nextEndDate.format('YYYY-MM-DD');

  return { startDate: nextStartDateString, endDate: nextEndDateString };
};

export const getNextPageParam = ({ endDate }: { endDate: any }) => {
  const { defaultEnd, defaultStart } = calculateCalendarInitialDates();

  // The Pagination Method produces a next "Page". When you re-fetch the query, you end up looking at the first page
  // And using this function to generate the next page. This will over-write each page's range and replace it with
  // The logic provided in this function. In our case, we have a default range that needs to be used as we initially
  // Fetch 15 months of logic. By looking at the end of the current page in this function, we can determine if the next
  // month is the start of the default range. If yes, set the next "Page" to use the default range.

  const endOfPageOneDayInFuture = dayjs(endDate).hour(0).add(1, 'day');
  const isEndDateTheStartofDefaultRange = endOfPageOneDayInFuture.isSame(defaultStart);

  if (isEndDateTheStartofDefaultRange) {
    return { startDate: defaultStart, endDate: defaultEnd };
  }

  const lastEndDate = dayjs(endDate);
  const nextStartDate = lastEndDate.add(1, 'day');
  const nextStartDateString = nextStartDate.format('YYYY-MM-DD');

  const nextEndDate = nextStartDate.endOf('month');
  const nextEndDateString = nextEndDate.format('YYYY-MM-DD');

  return { startDate: nextStartDateString, endDate: nextEndDateString };
};
